import Vue from 'vue'
import App from './App.vue'
import router from "./router";

Vue.config.productionTip = false

import Buefy from 'buefy'

Vue.use(Buefy);

import '@/assets/scss/main.scss'

import { Amplify } from 'aws-amplify';

import moment from 'moment'
Vue.prototype.moment = moment

Vue.use(Amplify);
Amplify.configure({
  Auth: {
    Cognito: {
      region: 'eu-central-1', // e.g., 'us-east-1'
      userPoolId: 'eu-central-1_HQCwnpOr4', // e.g., 'us-east-1_ABC1234'
      userPoolClientId: '4kdlue8s5aq1kjtptt044n5h81', // e.g., '1h2j3k4l5m6n'
    }
  },
});


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
